import { makeHttpRequest } from "@/shared";

import { mapCalculatedRepairFromServer } from "./mappers/mapCalculatedRepairFromServer";
import { mapRepairInventoryToServer } from "./mappers/mapRepairInventoryToServer";
export const removeRepairInventory = async (sessionKey, repairInventory) => {
    const response = (
        await makeHttpRequest({
            url: `/repair/builder/${sessionKey}/remove/inventory`,
            method: "DELETE",
            data: mapRepairInventoryToServer(repairInventory),
        })
    ).data;

    return mapCalculatedRepairFromServer(response.data);
};
